import React from "react";
import Auth from "../auth/Auth";
import API from "../base/API";
import Storage from "../base/Storage";
import SorTable from '../base/SorTable';
import { translate } from "../base/Translation";

export default class ErrorStatistics extends Auth {
    constructor(props) {
        super(props);

        this.api = new API({
            get_weaves: "/weave/fetch/all?limit_from=:from&limit_max=:to&brand=:brand",
            get_statistics: "/statistic_error/fetch?limit_from=:from&limit_max=:to&weave=:weave",
        });

        this.state = {
            weaves: [],
            statistics: [],
            tableData: [],
            selectedWeave: false,
            tableColumns: [
                { name: "name", display: translate("Chyba"), sort: true, width: 30 },
                { name: "success_rate", display: translate("Úspešnosť"), sort: true, width: 10 },
                { name: "occurences", display: translate("Počet výskytov"), sort: true, width: 12 },
                { name: "removed", display: translate("Odstránená"), sort: true, width: 10 },
                { name: "simulated", display: translate("Simulovaná"), sort: true, width: 10 },               
                { name: "group", display: translate("Skupina"), sort: true, width: 28 },            
            ]
        };
    }

    convertDataForTable(data) {
        return data.map(function (statistic) {
            statistic.success_rate = (
                <div>
                    <span style={{ display: "none" }}>{statistic.success_rate}</span>
                    <span>{statistic.success_rate + " %"}</span>
                </div>
            );
            statistic.name = statistic.error;
            return statistic;
        });
    }

    fetchData() {
        let brandFilter = Storage.get("brand_filter");
        this.api.request({
            cache: true,
            route: "get_weaves",
            params: { from: 0, to: 99999, withForms: true, brand: brandFilter ? brandFilter.id : "all" },
            success: (response) => {
                this.setState({ weaves: response, selectedWeave: response[0].id });
                this.loadStatistics(response[0].id);
            }
        });
    }

    componentDidMount() {
        this.fetchData();
    }

    loadStatistics(selectedWeave) {
        this.api.request({
            cache: true,
            route: "get_statistics",
            params: { from: 0, to: 99999, weave: selectedWeave},
            success: (response) => {
                let tableData = this.convertDataForTable(response);
                this.setState({ statistics: response, tableData });
            }
        });
    }

    onFilter(evt) {
        this.setState({ selectedWeave: evt.target.value });
        this.loadStatistics(evt.target.value);
    }

    render() {
        return (
            <SorTable columns={this.state.tableColumns} data={this.state.tableData} headers={true} searchBy="name" title={translate("Štatistiky")} right={() => {
                return (
                    <select
                        className="form-control input-sm pull-right"
                        style={{ maxWidth: "300px", marginLeft: "1rem" }}
                        onChange={this.onFilter.bind(this)}
                        value={this.state.selectedWeave}
                    >
                        {this.state.weaves.map((weave) => {
                            return <option key={weave.id} value={weave.id}>{weave.name}</option>
                        })}
                    </select>
                )
            }} />
        );
    }
}


// WEBPACK FOOTER //
// ./src/modules/error_statistic/ErrorStatistics.jsx